import moment from 'moment'

import { dateRangeToArray } from './dates'

export const MEETING_BASE_PATH = '/wb/meeting';
export const IS_MY_MANAGER = 1
export const IS_MY_REPORT = 2

export const meetingsMapByDate = (meetings, startTime, numDays) => {
  const endTime = moment(startTime).add(numDays - 1, 'd')
  const dateRange = dateRangeToArray(startTime, endTime)

  return dateRange.reduce((meetingsMap, date) => {
    const begOfDay = date.startOf('day').unix()
    const endOfDay = date.endOf('day').unix()

    const filteredMeetings = meetings.filter((meeting) => (
      meeting.startTime >= begOfDay && meeting.startTime <= endOfDay
    ))

    meetingsMap.set(date, filteredMeetings)

    return meetingsMap
  }, new Map())
}

// A series a legacy series, if the id is numeric
export const isLegacySeriesId = (seriesMasterId) => !Number.isNaN(Number(seriesMasterId))

export const isLinkableMeeting = (
  meeting,
) => {

  // not-available-for-wobo-enablement
  if (meeting.is1on1) {
    return false
  }

  // Meeting is a new meeting and is not linked an event
  if (!meeting.eventId) {
    return true
  }

  // If the meeting is legacy, don't allow linking
  if (parseInt(meeting.id, 10) === parseInt(meeting.eventId, 10)) {
    return false
  }

  return false
}

// generates a unique ID for a meeting (helpful for external meetings which don't have IDs)
export const uniqueId = (meeting) => {
  if (!meeting) {
    return ''
  }
  const meetingId = meeting.id && (meeting.id).toString()
  const eventId = meeting.eventId && (meeting.eventId).toString()

  return meetingId + eventId
}

export const convertTo1on1 = async ({
  attendee,
  setPutting,
  user,
  meeting,
  patch,
  loadMeeting,
  patchManagers,
  patchReports,
  setShowConfirmConvertTo1on1,
  setSnackbarState
}) => {
  const [attendeeUser, attendeeRole] = attendee
  if (user && attendeeUser) {
    setPutting(true)
    try {
      // Send model into patch so that it doesn't ignore convertTo1On1 property due to it not being in intial computedPayload
      await patch({
        payload: { ...meeting, convertTo1On1: true },
        model: { ...meeting, convertTo1On1: true },
      })
      await loadMeeting(meeting.id)

      if (attendeeRole === IS_MY_MANAGER) {
        patchManagers({ user: attendeeUser, meeting })
      }
      if (attendeeRole === IS_MY_REPORT) {
        patchReports({ user: attendeeUser, meeting })
      }
    } catch (error) {
      setPutting(false)
      setShowConfirmConvertTo1on1(false)
      setSnackbarState({ open: true, message: 'Failed to convert the agenda to 1on1', severity: 'error' })
    }
    setShowConfirmConvertTo1on1(false)
    setPutting(false)
  }
}

export const isMeetingLocal = (meeting) => {
  return String(meeting?.provider).toLowerCase() === 'workboard'
}

export const computeTopicDelta = (oldLegacyData = {}, newLegacyData = {}, userId) => {
  const delta = {
    topicsAdded: 0,
    topicsDeleted: 0,
    topicsUpdated: 0,
    takesAdded: 0,
    takesDeleted: 0,
    takesUpdated: 0
  };

  if (!oldLegacyData) oldLegacyData = {};
  if (!newLegacyData) newLegacyData = {};

  const addedBy = userId ?? (newLegacyData?.currentUser?.id ?? oldLegacyData?.currentUser?.id);
  const oldTopics = oldLegacyData.meeting_topics ? [...oldLegacyData.meeting_topics] : [];
  const newTopics = oldLegacyData.meeting_topics ? [...newLegacyData.meeting_topics] : [];
  let topicIndex;
  let oldTopic;

  newTopics.forEach(newTopic => {
    topicIndex = oldTopics.findIndex(oldTopic => oldTopic.id === newTopic.id);
    if (topicIndex !== -1){
      oldTopic = oldTopics[topicIndex];

      if (newTopic.description !== oldTopic.description && newTopic.added_by !== addedBy){
        delta.topicsUpdated++;
      }
      oldTopics.splice(topicIndex, 1);

      computeTakeDelta(oldTopic, newTopic, delta, addedBy);
    } else {
      if (newTopic.added_by !== addedBy) {
        delta.topicsAdded++;
        if (newTopic && newTopic.topic_take && !isNaN(newTopic.topic_take.length)) {
          delta.takesAdded += newTopic.topic_take.length;
        }
      }
    }
  });

  oldTopics.forEach(oldTopic => {
    if (oldTopic.added_by !== addedBy){
      delta.topicsDeleted++;
      if (oldTopic && oldTopic.topic_take && !isNaN(oldTopic.topic_take.length)) {
        delta.takesDeleted += oldTopic.topic_take.length;
      }
    }
  });

  delta.hasChanges = delta.topicsAdded > 0 || delta.topicsUpdated > 0 || delta.topicsDeleted > 0 ||
      delta.takesAdded > 0 || delta.takesUpdated > 0 || delta.takesDeleted > 0;

  return delta;
}

const computeTakeDelta = (oldTopic = {}, newTopic = {}, delta, addedBy) => {
  const oldTakes = [...oldTopic.topic_take];
  const newTakes = [...newTopic.topic_take];
  let takeIndex;

  newTakes.forEach(newTake => {
    takeIndex = oldTakes.findIndex(oldTake => oldTake.id === newTake.id);
    if (takeIndex !== -1){
      if (newTake.description !== oldTakes[takeIndex].description && newTake.added_by !== addedBy){
        delta.takesUpdated++;
      }
      oldTakes.splice(takeIndex, 1);
    } else {
      if (newTake.added_by !== addedBy) {
        delta.takesAdded++;
      }
    }
  });

  delta.takesDeleted += oldTakes.length;
  delta.syncedAt = Date.now();

  return delta;
}

export const isMeetingUrl = (path) => {
  return path?.includes(MEETING_BASE_PATH);
}
